import {useCallback, useState} from 'react';

// Each call to markCurrentSectionAsCleared generates a new key, so <Section key={...} /> remounts
// and runs mount-time logic again (initial values, onMount), like when navigating back to it
export const useSectionRemountKey = () => {
  const [sectionRemountKey, setSectionRemountKey] = useState(() => crypto.randomUUID());
  const markCurrentSectionAsCleared = useCallback((): void => setSectionRemountKey(crypto.randomUUID()), []);

  return {sectionRemountKey, markCurrentSectionAsCleared};
};
